import { Sparkline } from './Sparkline'

interface MetricCardProps {
  title: string
  value: string | number
  sparklineData: number[]
  sparklineColor?: string
  subtitle?: string
  tooltip?: string
  compact?: boolean
}

export function MetricCard({ title, value, sparklineData, sparklineColor, subtitle, tooltip, compact }: MetricCardProps) {
  const trend = sparklineData.length >= 2
    ? sparklineData[sparklineData.length - 1]! - sparklineData[sparklineData.length - 2]!
    : 0

  if (compact) {
    return (
      <div className="flex items-center justify-between px-2 py-1 min-w-0" title={tooltip}>
        <span className="text-[10px] text-gray-500 uppercase tracking-wider truncate mr-1">{title}</span>
        <span className="text-sm font-bold text-white whitespace-nowrap">{value}</span>
      </div>
    )
  }

  return (
    <div className="themed-panel border border-cosmic-border rounded-lg px-4 py-3 min-w-[140px]" title={tooltip}>
      <div className="text-xs text-gray-500 uppercase tracking-wider">{title}</div>
      <div className="flex items-end justify-between mt-1">
        <div>
          <div className="text-2xl font-bold text-white">{value}</div>
          {subtitle && <div className="text-xs text-gray-500">{subtitle}</div>}
        </div>
        <div className="flex flex-col items-end gap-1">
          <Sparkline data={sparklineData} color={sparklineColor} />
          {trend !== 0 && (
            <span className={`text-xs ${trend > 0 ? 'text-teal-400' : 'text-cosmic-plasma'}`}>
              {trend > 0 ? '\u2191' : '\u2193'} {Math.abs(trend)}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
